<script setup lang="ts">
import Review from "@/views/playground/player/partner/planner/Review.vue";
</script>
<template>
  <review></review>
</template>
<style scoped></style>
